
import { CustomInput, MarkupMainContainer } from '../../../StyledComponents/Markup';
import { HeadShort } from '../../../StyledComponents/Header';
import { Row, Col } from 'antd';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateMinimumMarkup } from '../../../store/Markup/markupSlice';
import { updatenotificationdata } from '../../../store/Common/CommonSlice';

export const MinimumMarkup = (props) => {
  const  {minimumMarkup}  = useSelector((state) => state?.markup);
  const [minimumMarkupValue, setMinimumMarkupValue] = useState("");
  const [editMinimum, setEditMinimumMarkup] = useState(false);
  const [updatedMinimumMarkup,setUpdatedMinimuMarkupValue]=useState(minimumMarkup)
  const dispatch = useDispatch();

 console.log(minimumMarkup,"minimumMarkup")

  const handleSubmit = (value) => {
    console.log(value,"value");
    // console.log("*****************",e)
    setMinimumMarkupValue(value)

  }
  const handleBlur = () => {
    const manpValue = {
      "min_markup_id": minimumMarkup?._id||updatedMinimumMarkup?._id,
      "markup_percentage": minimumMarkupValue
    }
   console.log("minimumMarkupValue",minimumMarkupValue,updatedMinimumMarkup)

    minimumMarkupValue && dispatch(updateMinimumMarkup(manpValue)).then((res) => {
      console.log("res",res)
      setUpdatedMinimuMarkupValue(res.payload.data);
      setMinimumMarkupValue(res.payload.data.markup_percentage)
      dispatch(updatenotificationdata(res.payload))
    }).catch((err) => {
      dispatch(updatenotificationdata(err))
    }).finally(() => {
      setEditMinimumMarkup(false)
      // console.log("finally is called ")
    })
    setEditMinimumMarkup(false)
  };

  return (
    <MarkupMainContainer>
      <Row align="middle" gutter={[16, 16]}>
        <Col xs={24} sm={8}>
          Minimum Markup %
        </Col>
        {/* <Col xs={24} sm={16}>
          <CustomInput
            type="text"
            placeholder="Filled"
            value={minimumMarkupValue==""?minimumMarkup?.markup_percentage:minimumMarkupValue}
            onChange={(e) => setMinimumMarkupValue(e.target.value)}
            onBlur={handleBlur}
          />
        </Col> */}

        <Col xs={24} sm={16} md={10}>
          {editMinimum ? (
            <CustomInput
              className="w-full"
              type="number"
              placeholder="Enter Minimum Markup Percentage"
              value={minimumMarkupValue}
              onChange={(e)=>handleSubmit(e.target.value)}
              onBlur={() => handleBlur()}
            />
          ) : (
            <div
              className="w-full p-2 border border-gray-300 rounded cursor-pointer"
              onClick={() => setEditMinimumMarkup(true)}
            >
              {minimumMarkup?.markup_percentage||minimumMarkupValue}
            </div>
          )}
        </Col>
      </Row>
      <HeadShort>
        Note: {props.note}
      </HeadShort>
    </MarkupMainContainer>
  );
};
